import type { CarFeatureConfig } from '../../../types/insurances/CarFeatureConfig';

export const car: CarFeatureConfig = {
    overview: {
        details: {
            showPackage: false,
            showRisksInList: true,
            showSpecialTranslationKeyForParticipationAllRisks: true,
            fallbackAssistancePhonesKey: 'CZ',
            fallbackAssistanceEmailsKey: 'CZ',
        },
    },
    history: {
        visible: true,
    },
};
